import { AddressSection } from './AddressSection';
import { BuyerSection } from './BuyerSection';
import { OrderlinesSection } from './OrderlinesSection';
import { PaymentMethodSection } from './PaymentMethodSection';
import { SummarySection } from './SummarySection';
import { ConsentSection } from './ConsentSection';
import { CashReceiptSection } from './CashReceiptSection';

export const Sections = Object.assign({
  Orderlines: OrderlinesSection,
  Buyer: BuyerSection,
  Address: AddressSection,
  PaymentMethod: PaymentMethodSection,
  Summary: SummarySection,
  Consent: ConsentSection,
  CashReceipt: CashReceiptSection,
});
